module.exports = __webpack_public_path__ + "img/picture_news.8288222c.jpg";